import { render } from "./CreatePracticeModal.vue?vue&type=template&id=4143af83&scoped=true"
import script from "./CreatePracticeModal.vue?vue&type=script&lang=js"
export * from "./CreatePracticeModal.vue?vue&type=script&lang=js"

import "./CreatePracticeModal.vue?vue&type=style&index=0&id=4143af83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4143af83"]])

export default __exports__